export const DEP_TYPE_NUM = {
  webinar: 1, // 直播间
  page: 4, // 单场大会
  series: 5, // 系列会
  website: 6 // 聚合主站
};
